import { defineAsyncComponent } from 'vue';

export default {
	forms: {
		edit: {
			panel: {
				// height: '280px',
				width: '50%'
			},
			component: defineAsyncComponent(() => import('./forms/Edit.vue'))
		},
		list: {
			component: defineAsyncComponent(() => import('./forms/List.vue'))
		},
		select: {
			panel: {
				width: '50%',
				height: '60%'
			},
			config: {
				fields: {
					name: {
						config: {
							width: '60%'
						}
					},
					narcotic: {
						config: {
							width: '5%'
						}
					},
					pku: {
						config: {
							width: '5%'
						}
					}
				}
			}
		}
	}
}